import { Record } from 'immutable';

export default class PaymentRecord extends Record({
  id: undefined,
  bookingPaymentItemAttestedDates: undefined,
  bookingReportPeriodPaymentCredits: undefined,
  bookingReportPeriods: undefined,
  createdAt: undefined,
  createdBy: undefined,
  date: undefined,
  firstName: undefined,
  forSelfEmployed: undefined,
  grossAmount: undefined,
  taxableGrossAmount: undefined,
  nonTaxableGrossAmount: undefined,
  lastName: undefined,
  links: undefined,
  mileageAllowances: undefined,
  netAmount: undefined,
  paidAt: undefined,
  paymentNumber: undefined,
  paymentRows: undefined,
  resource: undefined,
  rounding: undefined,
  selfEmployedBrutto: undefined,
  settings: undefined,
  staffingCompany: undefined,
  taxAmount: undefined,
  taxRate: undefined,
  vatAmount: undefined,
  vatRate: undefined,
  inFortnoxSince: undefined,
}) {
}
